import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../data/company';

export function SubpageHero({
  badge = "Altmuligmanden Juelsminde",
  title,
  subtitle,
  icon,
  breadcrumbs = [],
  children,
  showQuickContact = true,
}) {
  return (
    <section className="relative bg-[#111823] text-white py-8 sm:py-12 overflow-hidden border-b border-[#2193BB]/30">
      {/* Background Grid & Radial Lighting */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" />
      <div 
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 50% 20%, rgba(33, 147, 187, 0.15) 0%, transparent 70%)'
        }}
      />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6">
        {/* Breadcrumb Navigation */}
        <div className="flex flex-wrap items-center justify-center gap-1.5 text-[11px] font-medium text-[#9D9D9D] mb-3">
          <Link 
            to="/" 
            className="hover:text-[#2193BB] transition-colors flex items-center gap-1 cursor-pointer"
          >
            <i className="fa-solid fa-house text-[10px]" aria-hidden="true" />
            <span>Forside</span>
          </Link>
          
          {breadcrumbs.map((crumb, idx) => (
            <span key={idx} className="inline-flex items-center gap-1.5">
              <i className="fa-solid fa-chevron-right text-[8px] text-[#9D9D9D]/40" aria-hidden="true" />
              {crumb.link ? (
                <Link 
                  to={crumb.link} 
                  className="hover:text-[#2193BB] transition-colors cursor-pointer"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-white font-semibold">{crumb.label}</span>
              )}
            </span>
          ))}
        </div>

        {/* Hero Content Stack */}
        <div className="flex flex-col items-center text-center space-y-3 max-w-xl mx-auto">
          
          {/* Optional Icon Spotlight */}
          {icon && (
            <div className="relative group mb-0.5">
              <div className="relative w-12 h-12 bg-[#16212d] text-[#2193BB] rounded-xl flex items-center justify-center text-xl border border-[#2193BB]/30 shadow-md">
                <i className={icon} aria-hidden="true" />
              </div>
            </div>
          )}

          {/* Title */}
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight text-white leading-tight">
            {title}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p className="text-[#9D9D9D] text-xs sm:text-sm max-w-lg leading-relaxed">
              {subtitle}
            </p>
          )}

          {/* Children / Custom Action Slot */}
          {children}

          {/* Quick Contact & Coverage Bar */}
          {showQuickContact && !children && (
            <div className="pt-2 flex flex-wrap justify-center items-center gap-2.5">
              <Link
                to="/kontakt"
                className="bg-[#2193BB] hover:bg-[#1b7da0] text-white font-medium px-4 py-2 rounded-lg shadow transition-all cursor-pointer text-xs flex items-center gap-1.5 group"
              >
                <i className="fa-solid fa-paper-plane text-[10px] transform group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />
                <span>Indhent tilbud</span>
              </Link>

              <a
                href={`tel:${COMPANY.phone}`}
                className="bg-[#1a2634] hover:bg-[#223245] text-white font-medium px-4 py-2 rounded-lg border border-[#9D9D9D]/20 transition-all text-xs flex items-center gap-1.5 whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-[#2193BB] text-[10px]" aria-hidden="true" />
                <span className="whitespace-nowrap">Ring: {COMPANY.phoneFormatted}</span>
              </a>
            </div>
          )}

        </div>

      </div>

      {/* Decorative Bottom Accent Bar */}
      <div className="absolute bottom-0 inset-x-0 h-0.5 bg-gradient-to-r from-transparent via-[#2193BB]/30 to-transparent" />
    </section>
  );
}
